import { render, staticRenderFns } from "./UserHolidays.vue?vue&type=template&id=6a01b363&"
import script from "./UserHolidays.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserHolidays.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports